
import * as actionTypes from './actionType';

export const selectXML = (xmlID) => { return {type: actionTypes.SET_XML, 'currentXMLID': xmlID} }
